"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokens = void 0;
const assets_1 = require("./assets");
exports.tokens = {
    ETH: {
        symbol: 'ETH',
        name: 'Ethereum',
        decimals: 18,
        image: assets_1.ETHImage
    },
    XDAI: {
        symbol: 'XDAI',
        name: 'XDAI',
        decimals: 18,
        image: assets_1.XDAIImage
    },
    MATIC: {
        symbol: 'MATIC',
        name: 'Matic',
        decimals: 18,
        image: assets_1.MATICImage
    },
    DAI: {
        symbol: 'DAI',
        name: 'DAI Stablecoin',
        decimals: 18,
        image: assets_1.DAIImage
    },
    ARB: {
        symbol: 'ARB',
        name: 'ARB Token',
        decimals: 18,
        image: assets_1.ARBImage
    },
    sETH: {
        symbol: 'sETH',
        name: 'Synth ETH',
        decimals: 18,
        image: assets_1.sETHImage
    },
    sBTC: {
        symbol: 'sBTC',
        name: 'Synth BTC',
        decimals: 18,
        image: assets_1.sBTCImage
    },
    USDC: {
        symbol: 'USDC',
        name: 'USD Coin',
        decimals: 6,
        image: assets_1.USDCImage
    },
    USDT: {
        symbol: 'USDT',
        name: 'Tether USD',
        decimals: 6,
        image: assets_1.USDTImage
    },
    WBTC: {
        symbol: 'WBTC',
        name: 'Wrapped BTC',
        decimals: 8,
        image: assets_1.WBTCImage
    },
    HOP: {
        symbol: 'HOP',
        name: 'Hop',
        decimals: 18,
        image: assets_1.HOPImage
    },
    OP: {
        symbol: 'OP',
        name: 'Optimism',
        decimals: 18,
        image: assets_1.OPImage
    },
    SNX: {
        symbol: 'SNX',
        name: 'Synthetix Network Token',
        decimals: 18,
        image: assets_1.SNXImage
    },
    sUSD: {
        symbol: 'sUSD',
        name: 'Synth sUSD',
        decimals: 18,
        image: assets_1.sUSDImage
    },
    GNO: {
        symbol: 'GNO',
        name: 'Gnosis',
        decimals: 18,
        image: assets_1.GNOImage
    },
    rETH: {
        symbol: 'rETH',
        name: 'Rocket Pool ETH',
        decimals: 18,
        image: assets_1.rETHImage
    }
};
